import { render, staticRenderFns } from "./ServiceNewItemModal.vue?vue&type=template&id=038e9d4a&"
import script from "./ServiceNewItemModal.vue?vue&type=script&lang=ts&"
export * from "./ServiceNewItemModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports